import { render, staticRenderFns } from "./OrderActionRefundItemAmount.vue?vue&type=template&id=70296064&"
import script from "./OrderActionRefundItemAmount.vue?vue&type=script&lang=ts&"
export * from "./OrderActionRefundItemAmount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports